import {
  useQueryStates,
  parseAsArrayOf,
  parseAsString,
  createParser,
} from 'nuqs'

const parseAsStringArrayAllowEmpty = createParser<string[]>({
  parse(queryValue) {
    if (queryValue === '') return []
    return parseAsArrayOf(parseAsString).parse(queryValue)
  },
  serialize(value: string[]) {
    return parseAsArrayOf(parseAsString).serialize(value)
  },
  eq(a, b) {
    return a.length === b.length && a.every((v, i) => v === b[i])
  },
})

export const useDayforceWebhooksFiltersQueryState = () => {
  return useQueryStates(
    {
      agencyId: parseAsStringArrayAllowEmpty.withDefault([
        '5b488f4f-391f-405a-87ca-1811a0f63ac8', // WorkWhile prod agency
      ]),
      eventType: parseAsStringArrayAllowEmpty.withDefault([]),
      status: parseAsStringArrayAllowEmpty.withDefault([
        'created',
        'attempted',
        'failed',
        'invalid_payload',
      ]),
    },
    {
      urlKeys: {
        agencyId: 'agency-id',
        eventType: 'event-type',
        status: 'webhook-status',
      },
    }
  )
}
